(() => {
  function setupVariantIdsOnProductPageProductVariantSwatchs() {
    const swatches = document.querySelectorAll('.swatch-view li');

    swatches.forEach((swatch) => {
      const variantId = swatch.getAttribute('option-value-id')
      swatch.setAttribute('data-variant-id', variantId);
    })
  } 
  
  function getPromotionFromScript() {
    const scriptElement = document.getElementById('AbraPublicPromotion');

    if (scriptElement && scriptElement.textContent) {
      try {
        return JSON.parse(scriptElement.textContent);
      } catch (err) {
        console.log(err)
      }
    }

    return null;
  }

  const countryIsoCode = window.Shopify.country;
  let currentPromotionCode = "";

  const stored = window.localStorage.getItem("abra:active-promotion");

  if (stored) {
    const temp = JSON.parse(stored);
    if (temp.expiresAt >= Date.now()) {
      currentPromotionCode = temp.promotion.code;
    }
  }

  window.addEventListener('abra:initialized', async () => {
    if (window.location.href.includes('soft-play-foam-block-set-corner-climber')) {
      const publicPromotion = getPromotionFromScript();
      
      if (publicPromotion) {
        await window.Abra.activate(publicPromotion.code, null, {
          promotion: publicPromotion,
        });

        window.dispatchEvent(new CustomEvent('abra:render'))
      }

      return;
    }

    if (countryIsoCode === 'US' && currentPromotionCode !== 'BACKTOSCHOOL') {
      await window.Abra.activate('BACKTOSCHOOL');
    }

    if (countryIsoCode === 'GB' && currentPromotionCode !== 'BACKTOSCHOOL-UK') {
      await window.Abra.activate('BACKTOSCHOOL-UK');
    }

    if (countryIsoCode === 'CA' && currentPromotionCode !== 'BACKTOSCHOOL-CA') {
      await window.Abra.activate('BACKTOSCHOOL-CA');
    }

    if (countryIsoCode === 'AU' && currentPromotionCode !== 'BACKTOSCHOOL-AU') {
      await window.Abra.activate('BACKTOSCHOOL-AU');
    }

    window.dispatchEvent(new CustomEvent('abra:render'))
  });

  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      const swatchItems = document.querySelectorAll('variant-swatch-king li');
      const navigationArrows =
        document.querySelectorAll('.swatch-navigation');

      navigationArrows.forEach((navigationArrow) => {
        setVariantIdAttribute(navigationArrow);

        navigationArrow.addEventListener('click', (event) => {
          setVariantIdAttribute(navigationArrow);
        });
      });

      swatchItems.forEach((swatchItem) => {
        setVariantIdAttribute(swatchItem);

        swatchItem.addEventListener('click', () => {
          setVariantIdAttribute(swatchItem);
        });
      });

      function setVariantIdAttribute(element) {
        setTimeout(() => {
          const cardWrapper = element.closest('.card-wrapper');

          const linkWithVariant = cardWrapper?.querySelector(
            '.card__content .card__information h3.card__heading a',
          );

          if (linkWithVariant && cardWrapper) {
            const variantHref = linkWithVariant.href;

            const variantId = variantHref.match(/variant=([^&]+)/)?.[1];

            if (variantId) {
              cardWrapper.setAttribute('data-variant-id', variantId);
            }
          }

          window.dispatchEvent(new CustomEvent('abra:render'));
        }, 500);
      }
    }, 1000);
  });
})();